export default __webpack_public_path__ + "static/media/DreamJobs2_19.708da206.png";